import { Typography, TypographyProps } from '@mui/material';
import { color } from '@/colors';

type AppTypographyProps = TypographyProps & {
  text?: string;
};

export const TextStdRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-std-rg" color={color.White64_T} {...props}>
    {text || children}
  </Typography>
);

export const TextStdMd = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-std-md" {...props}>
    {text || children}
  </Typography>
);

export const TextLgMd = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-lg-md" {...props}>
    {text || children}
  </Typography>
);

export const TextSmRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-sm-rg" {...props}>
    {text || children}
  </Typography>
);

export const TextSmMd = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-sm-md" {...props}>
    {text || children}
  </Typography>
);

export const LabelSmRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="label-sm-rg" {...props}>
    {text || children}
  </Typography>
);
